import { render, staticRenderFns } from "./AssigneeModal.vue?vue&type=template&id=6e8c0f48&scoped=true"
import script from "./AssigneeModal.vue?vue&type=script&lang=js"
export * from "./AssigneeModal.vue?vue&type=script&lang=js"
import style0 from "./AssigneeModal.vue?vue&type=style&index=0&id=6e8c0f48&prod&scoped=true&lang=css"
import style1 from "./AssigneeModal.vue?vue&type=style&index=1&id=6e8c0f48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8c0f48",
  null
  
)

export default component.exports